import {
  useContext,
  useEffect
} from 'react';

import {
  useHistory,
  useLocation
} from 'react-router-dom';

import {
  Environment
} from '@vodacom/web-env';

import {
  getStorageWithExpiry,
  isFeatureEnabled,
  isValidEncMsisdn
} from 'helpers';

import {
  FeatureToggles
} from '../constants';

import {
  AppContext
} from 'context';

export const MsisdnCheck = () => {

  const { replace } = useHistory();
  const { pathname } = useLocation();
  const { config } = useContext(AppContext);

  const isNonProd = () => {

    return Environment.current?.env === 'dev' || Environment.current?.env === 'qa';
  };

  useEffect(() => {

    const init = async () => {

      if (!isFeatureEnabled(config, FeatureToggles.EnableHeaderEnrichment)) {
        return;
      }

      if (
        !isValidEncMsisdn(getStorageWithExpiry('msisdn', 'encMsisdn'))
        && pathname !== '/'
        && (isFeatureEnabled(config, FeatureToggles.EnableLiteSplashPage) || !isNonProd())
      ) {

        if (isFeatureEnabled(config, FeatureToggles.EnableLiteSplashPage)){
          window.location = '/';
          return;
        }

        replace('/');
      }

    };

    init();

  }, [ pathname, replace ]);

  return null;
};
